import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const usePermissionStore = create(persist((set: any) => ({
    permissions: [''],
    setPermissions: async (permissionsArray: any) => { set({ permissions: permissionsArray }) },
    removePermissions: () => set({ permissions: [''] }),
    // updateBears: (newBears) => set({ bears: newBears }),
}), { name: 'permissions-storage', storage: createJSONStorage(() => sessionStorage) } // Name of the item in the storage (must be unique),
));

export const useTenantStore = create(persist((set: any) => ({
    tenant: '',
    setTenant: (tenantId: string) => { set({ tenant: tenantId }) },
    removeTenant: () => set({ tenant: '' })
}), { name: 'tenant', storage: createJSONStorage(() => sessionStorage) }, // Unique storage key
));
